import ManualBookkeepingEntry from '../../Bookkeeping/ManualBookkeepingEntry';

/**
 * Compatibility route for existing edit-verification links.
 *
 * Create, copy and edit deliberately share one editor so their interaction,
 * validation and visual language cannot drift apart again. In edit mode the
 * editor uses the replace endpoint: the original is annulled and a corrected
 * verification is created, preserving the accounting history.
 */
const EditVerification = () => <ManualBookkeepingEntry mode="edit" />;

export default EditVerification;
